import { gql } from 'graphql.macro';

export const UpdateUser = gql`
    mutation UpdateUser($userId: Int!,  $profileIds: [Short!], $permissionSets: [UserPermissionSetRequestModelInput]){
        updateUser(userId: $userId, profileIds: $profileIds, permissionSets: $permissionSets)
    }
`;